"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "lazy", {
  enumerable: true,
  get: function get() {
    return _HOC.lazy;
  }
});
Object.defineProperty(exports, "drainHydrateMarks", {
  enumerable: true,
  get: function get() {
    return _marks.drainHydrateMarks;
  }
});
Object.defineProperty(exports, "printDrainHydrateMarks", {
  enumerable: true,
  get: function get() {
    return _marks.printDrainHydrateMarks;
  }
});
Object.defineProperty(exports, "rehydrateMarks", {
  enumerable: true,
  get: function get() {
    return _marks.rehydrateMarks;
  }
});
Object.defineProperty(exports, "loadableResource", {
  enumerable: true,
  get: function get() {
    return _loadable.default;
  }
});
Object.defineProperty(exports, "whenComponentsReady", {
  enumerable: true,
  get: function get() {
    return _loadable.done;
  }
});
Object.defineProperty(exports, "dryRender", {
  enumerable: true,
  get: function get() {
    return _loadable.dryRender;
  }
});
Object.defineProperty(exports, "assignImportedComponents", {
  enumerable: true,
  get: function get() {
    return _loadable.assignImportedComponents;
  }
});
Object.defineProperty(exports, "ComponentLoader", {
  enumerable: true,
  get: function get() {
    return _Component.default;
  }
});
Object.defineProperty(exports, "ImportedStream", {
  enumerable: true,
  get: function get() {
    return _context.ImportedStream;
  }
});
Object.defineProperty(exports, "LazyBoundary", {
  enumerable: true,
  get: function get() {
    return _LazyBoundary.default;
  }
});
exports.default = exports.setConfiguration = void 0;

var _HOC = _interopRequireWildcard(require("./HOC"));

var _marks = require("./marks");

var _loadable = _interopRequireWildcard(require("./loadable"));

var _Component = _interopRequireWildcard(require("./Component"));

var _context = require("./context");

var _LazyBoundary = _interopRequireDefault(require("./LazyBoundary"));

var setConfiguration = function setConfiguration(config) {
  return Object.assign(_Component.settings, config);
};

exports.setConfiguration = setConfiguration;
var _default = _HOC.default;
exports.default = _default;